import _ from 'lodash';

class ViewpaybillController {
    constructor($timeout, $scope, navigationManager, mockService, authService, billingService,$filter,storage,$state,
                $rootScope, $interval, $window, analyticsService) {
        this.$timeout = $timeout;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.name = 'View & Pay My Bill';

        var now = new Date();
        this.currentDay = $filter('date')(now, 'EEE');
        this.currentDate = $filter('date')(now, 'MM');
        this.currentMonth = $filter('date')(now, 'dd');

        this.currunttime = this._getTime();
        this.msgString = "This is your total amount due. This includes all activity processed up to " + this.currunttime + ", today.";
        this.paymentSuccessString = "This is the most current information available to both our systems and customer service agents. It includes all credits and payments processed up through " + this.currunttime + ", today.";
        this.lastPaymentDate = '';
        this.paymentAlertMsg = 'ERROR!';

        this.$scope = $scope;

        this.paymentMethodUsed = '';



        this.amountTestDue = 0;
        this.paymentMethodList =[];
        this.items=[];
        this.bpGlobalInfo = null;
        this.currentPaymentMethod = '';
        this.amountDueDate = '';



        /*************************************************************************/
        /*   The below block is to set the flags on the basis of bpglobal call    */
        /*************************************************************************/


        this.displayPaymentModal = false;
        this.showAlert = false;
        this.loading = false;
        this.paymentDue = false;
        this.noPaymentDue = false;
        this.creditBalance = false;
        this.noPaymentDuewithAccBalance = false;
        this.successPay = false;
        this.errorPay = false;
        this.isPastDue=false;
        this.isPreDAuthOne = false;
        this.isPreDAuthTwo = false;
        this.defaultExpiredPaymentText = false;
        this.deAuthInfo=null;
        this.currentAccount=null;
        this.isBlockedCustomer = false;
        /* */
        this.displayModalContent = true;
        this.bpGlobalDataLoader = true;

        //this is for alert box
        this.displayAlertModal = false;
        this.alertMsgTwo = '';
        this.alertMsgOne='';
        this.alertMsgTitle='';
        this.isTechFailureAlert=false;
        this.isRoutingOne = false;
        this.isValidDecline = false;
        this.isInvalidCC = false;
        this.isInvalidCCExDate = false;
        this.onlyOnePaymentMethodAfterError = false;
        this.multiVersionDeauth = false;

        //scheduling
        this.schedulePayment = null;

        //bpglobal with or without optimumid
        this.hasOptimumId=false;

      // omniture on view pay bill
      $scope.linkURL = null;
      $scope.event = null;
      $scope.channelName = 'my bill';
      $scope.pageName = null;
      $scope.linkName = null;
      $scope.omnitureBillingStatus = this.$rootScope.omnitureBillingStatus;
      $scope.omniturePaperlessbill = this.$rootScope.omniturePaperlessbill;
      $scope.omnitureErrorMsg = null;
      this.popup = true;

      this.$onInit = function () {
        this.totalPaymentMethod = this.$rootScope.totalPaymentMethod;
      }

      this.$onDestroy = function () {
        this.$rootScope.totalPaymentMethod = this.totalPaymentMethod;
      }

      $scope.$watch('[pageName, event]', function (newValue, oldValue) {
        console.log('!! omniture watch variables from view pay bill, event : ' +$scope.event +' pageName : ' +$scope.pageName +' linkName : '
          +$scope.linkName +' error message : ' +$scope.omnitureErrorMsg);
        if($scope.pageName) {
          console.log('inside if viewpaybill watch variables');
          analyticsService.sendReport('my bill', $scope.pageName, $scope.event, $scope.omnitureErrorMsg, null, null,
          $scope.linkName, $scope.linkURL, $scope.omnitureBillingStatus, $scope.omniturePaperlessbill);
          $scope.linkName = null;
          $scope.linkURL = null;
          $scope.omnitureErrorMsg = null;
        }
      });

        this.keyWatch = event => {
          window.addEventListener('keydown', this.keydown,false);
        };

        this.keydown = (event)=> {
          event.stopPropagation();
          if(!this.displayAlertModal && !this.displayPaymentModal){
            if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
              window.removeEventListener('keydown', this.keydown);
              this.$state.go('home.landingpage');
            }
          } else {
            console.log("Back button should not work");
          }
        };

        billingService.getBpGlobalData().then((res)=>{
            if(res && res.data && res.data.status && res.data.status.statusCode === "00000"){
                console.log("view bpGlobalInfo: ", res.data);
                this.bpGlobalInfo = res.data;
                this.amountTestDue = res.data.amountDue;

                if(this.bpGlobalInfo.dueDate !== null) {
                  var myDate = this.bpGlobalInfo.dueDate;
                  const parts = myDate.split('/');
                  myDate = parts[0] + '/' + parts[1];
                  this.amountDueDate = myDate;
                }

                if(this.bpGlobalInfo.recentPayDate !== null) {
                  var recentDate = this.bpGlobalInfo.recentPayDate;
                  const parts1 = recentDate.split('/');
                  recentDate = parts1[0] + '/' + parts1[1];
                  this.recentPaymentDate = recentDate;
                }

                // checking amount due in different phases
                if(this.bpGlobalInfo.currentBalance < 0){
                  this.creditBalance = true;
                  this.creditAmount = (this.bpGlobalInfo.currentBalance * -1);
                  //this block is just to check for schedule payment
                  billingService.getCurrectAcc().then((resp)=>{
                    if(resp){
                      this.currentAccount = resp;
                      //code for schedule payment
                      let autoPay =  this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
                      let oTPay = this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
                      let scheduleTrue = this.getScheduledPay(autoPay,oTPay);
                      if(scheduleTrue){
                        this.schedulePayment = 'Your next payment is scheduled on '+scheduleTrue.getFormattedDate()+' for '+$filter('currency')(scheduleTrue.amount, '$', 2);
                      }
                      //end schedule payment
                    }
                  }).then(()=>{
                      this.bpGlobalDataLoader = false;
                  });
                  //end of schedule payment block
                }
                else if(this.bpGlobalInfo.amountDue <= 0) {

                  if(this.bpGlobalInfo.currentBalance > 0) {
                    this.noPaymentDuewithAccBalance = true;
                  } else {
                    this.noPaymentDue = true;
                  }

                    //omniture when pay my bill loaded with no payment due
                    console.log('!!omniture when pay my bill loaded with no payment due');
                    analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, 
                      $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/viewpaybill');
                    //this block is just to check for schedule payment
                    billingService.getCurrectAcc().then((resp)=>{
                      if(resp){
                        this.currentAccount = resp;
                        //code for schedule payment
                        let autoPay =  this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
                        let oTPay = this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
                        let scheduleTrue = this.getScheduledPay(autoPay,oTPay);
                        if(scheduleTrue){
                          this.schedulePayment = 'Your next payment is scheduled on '+scheduleTrue.getFormattedDate()+' for '+$filter('currency')(scheduleTrue.amount, '$', 2);
                        }
                        //end schedule payment
                      }
                    }).then(()=>{
                      this.bpGlobalDataLoader = false;
                    });
                    //end of schedule payment block
                }
                else if(this.bpGlobalInfo.amountDue > 0){

                    //verifying from where bp global coming
                    if(storage.getItem('session','hasOptimumId')){
                      this.hasOptimumId=true;
                    } else {
                      //!!omniture no id associated
                      $scope.event = 'event1, event3, event10';
                      $scope.pageName = 'view & pay my bill';
                      $scope.omnitureErrorMsg = 'no associated id'
                      console.log('!!omniture no id associated : ' +$scope.event +' Error msg : ' +$scope.omnitureErrorMsg);
                    }

                  // first we will get list of cards by getCurracc
                    billingService.getCurrectAcc().then((resp)=>{
                      console.log("resp:", resp);
                      if(resp && resp.paymentMethods){

                        if(resp.paymentMethods.length === 0 || this.totalPaymentMethod === 0) {
                          //!!omniture no payment method
                          $scope.event = 'event1, event3, event10';
                          $scope.pageName = 'view & pay my bill';
                          $scope.omnitureErrorMsg = 'no payment method';
                          console.log('!!omniture no payment method : ' +$scope.event +' Error msg : ' +$scope.omnitureErrorMsg);
                        } else if(this.hasOptimumId = true && resp.paymentMethods.length !== 0) {
                          //omniture when pay my bill loaded with optimum id and payment method
                          console.log('!!omniture when pay my bill loaded with optimum id and payment method');
                          analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, 
                            $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/viewpaybill');
                        } 

                        this.totalPaymentMethod = resp.paymentMethods.length;
                        this.currentAccount = resp;
                        var tempItems = _.map(resp.paymentMethods, 'payMethodName');
                        for (var i in tempItems) {
                          var testString = 'Pay '+ $filter('currency')(this.amountTestDue, '$', 2) +' with '+tempItems[i];
                          var testObj = {
                            'title': testString,
                            'payment_method': tempItems[i],
                            'amount_due': this.amountTestDue
                          };
                          this.paymentMethodList.push(testObj);
                        }
                        if(storage.getItem('session', 'paymentMethods')){
                          this.items = storage.getItem('session', 'paymentMethods');
                        }
                        else{
                          this.items = this.paymentMethodList;
                          storage.setItem('session', 'paymentMethods', this.items);
                        }
                        //code for schedule payment
                        var autoPay =  this.createScheduledPayData(resp.scheduledAutoDate, resp.scheduledAutoAmount);
                        var oTPay = this.createScheduledPayData(resp.scheduledOTDate, resp.scheduledOTAmount);
                        var scheduleTrue = this.getScheduledPay(autoPay,oTPay);
                        if(scheduleTrue){
                          this.schedulePayment = 'Your next payment is scheduled on '+scheduleTrue.getFormattedDate()+' for '+$filter('currency')(scheduleTrue.amount, '$', 2);
                        }
                        //end schedule payment
                      }
                      else {
                        this.items = [];
                      }
                    }).then(()=>{
                      //blocked customer
                      // this is for test blocked one if(true){
                      if(this.currentAccount && this.currentAccount.manualBlockInd === "true"){
                        //!!omniture payment blocker
                        $scope.event = 'event1, event3, event10';
                        console.log('!!omniture payment blocker : ' +$scope.event);
                        this.errorPay = true;
                        this.successPay = false;
                        // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
                        document.getElementById('msgAlertBoxId').classList.add('styleAlert');
                        this.items = [];
                        this.isBlockedCustomer = true;
                        this.paymentAlertMsg = "Please visit your nearest Optimum store to make a cash-only payment on your account.";
                        //this is for format amount box if it is in amount
                        if(this.bpGlobalInfo.billPayCache && ((this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && this.bpGlobalInfo.billPayCache.deAuthBalanceDue!= 0) || this.bpGlobalInfo.pastDueAmount > 0)){
                          this.multiVersionDeauth = true;
                        }
                        this.paymentDue = true;
                        this.bpGlobalDataLoader = false;
                      }
                      //default card is expired
                      else if(this.currentAccount && this.currentAccount.defaultPaymentExpired){
                        this.errorPay = true;
                        this.successPay = false;
                        // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
                        document.getElementById('msgAlertBoxId').classList.add('styleAlert');
                        /*document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
                        document.getElementById('msgAlertBoxId').style.marginTop = '3.4vh';*/
                        if(this.items.length>0){
                          //!!omniture payment method expired
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event1, event3'; 
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event1, event3, event10';
                            this.totalPaymentMethod --;
                          }
                          console.log('!!omniture payment method expired : ' +$scope.event);
                          this.paymentAlertMsg= this.currentAccount.defaultPaymentName+' has expired. Please select another payment method to continue.';
                        }
                        else{
                          this.paymentAlertMsg= this.currentAccount.defaultPaymentName+' has expired.';
                          this.defaultExpiredPaymentText = true;
                        }
                        //this is for format amount box if it is in amount
                        if(this.bpGlobalInfo.billPayCache && ((this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0) || this.bpGlobalInfo.pastDueAmount > 0)){
                          this.multiVersionDeauth = true;
                        }
                        this.paymentDue = true;
                        this.bpGlobalDataLoader = false;
                      }
                      //this block plays pre-de auth one or two
                      else if(this.bpGlobalInfo.billPayCache && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != null && this.bpGlobalInfo.billPayCache.deAuthBalanceDue != 0){
                        this.deAuthInfo = billingService.deauthInfo(this.bpGlobalInfo.billPayCache);
                        //here we know we have deauth so now determining one or two so set text for alert and other msg.
                        this.errorPay = true;
                        this.successPay = false;
                        //document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
                        // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
                        document.getElementById('msgAlertBoxId').classList.add('styleAlert');
                        this.msgString='Pay now or go to optimum.net/pay-bill to pay your bill.';
                        if(this.deAuthInfo.isDeauthTwo){
                          this.isPreDAuthTwo = true;
                          this.paymentAlertMsg='Your account is past due. Make a payment now to avoid service interruptions.';
                        }else if(this.deAuthInfo.isDeauthOne){
                          this.isPreDAuthOne = true;
                          this.paymentAlertMsg='Your account is past due.  Please make a payment by '+this.deAuthInfo.startDate+' to avoid late fees or service interruptions.';
                        }
                        this.bpGlobalDataLoader = false;
                      }
                      ///this block plays pastdue stuff
                      else if(this.bpGlobalInfo.pastDueAmount > 0){
                        this.errorPay = true;
                        this.successPay = false;
                        this.paymentAlertMsg='Your account is past due. Please make a payment to avoid late fees or service interruptions.';
                        //document.getElementById('msgAlertBoxId').style.marginBottom = '2vh';
                        // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
                        document.getElementById('msgAlertBoxId').classList.add('styleAlert');
                        this.msgString='Pay now or go to optimum.net/pay-bill to pay your bill.';
                        this.isPastDue=true;
                        this.bpGlobalDataLoader = false;
                      }
                      //if nothings remain and only amount due
                      else{
                        this.paymentDue = true;
                        this.bpGlobalDataLoader = false;
                      }

                      //focus the carousel
                      if(this.items.length > 0) {
                      this.focusItem('btn-scrolling-list');
                      }
                    });
                }
            }
            else{
              this.$state.go('home.landingpage');
            }
        },()=>{
              console.log('Something wrong with all call and bpglobal fail.');
        });


        /*************************************************************************/
        /*   The below block is to set the flagson the basis of bpglobal call    */
        /*************************************************************************/

        navigationManager.registerViewComponent(this, $scope, 'home.viewpaybill');
        navigationManager.registerNavigate('confirm-btn', 'down');
        navigationManager.registerNavigate('confirm-btn', 'left', 'cancel-btn');
        navigationManager.registerNavigate('confirm-btn', 'up');
        navigationManager.registerNavigate('confirm-btn', 'right');
        navigationManager.registerNavigate('cancel-btn', 'down');
        navigationManager.registerNavigate('cancel-btn', 'right', 'confirm-btn');
        navigationManager.registerNavigate('cancel-btn', 'up');
        navigationManager.registerNavigate('cancel-btn', 'left');

        this.paymentModalHandler = item => {
            if(this.popup) {
              $scope.pageName = 'review';
              $scope.event = 'event1, event4';
              console.log('!!omniture mybill review : ' +$scope.event);
            }
            this.displayPaymentModal = true;
            this.displayModalContent = true;
            console.log("item:", item);
            this.paymentMethodUsed = item.payment_method;
            setTimeout(function() {
                document.getElementById('confirm-btn').focus();
            }, 100);
        };

        this.cancel = _ => {
          //!!omniture mybill review cancel
          this.popup = false;
          $scope.event = null;
          $scope.linkName = 'cancel';
          $scope.linkURL = this.$rootScope.analytics.omniturePath +'/viewpaybill';
          $scope.pageName = 'review';
          console.log('!!omniture mybill review, cancel : ' +$scope.event +' , link Name : ' +$scope.linkName);
          this.displayPaymentModal = false;
            this.focusItem('btn-scrolling-list');
        };

        this.confirm = (pmName, amtDue) => {
            //!!omniture mybill review confirm TODO: only tag once per flow
            this.popup = false;
            $scope.event = 'event5';
            $scope.linkName = 'confirm';
            $scope.linkURL = this.$rootScope.analytics.omniturePath +'/viewpaybill';
            $scope.pageName = 'review';
            console.log('!!omniture mybill review, confirm : ' +$scope.event +' , link Name : ' +$scope.linkName);
            this.displayModalContent = false;
            this.loading = true;

            // The api here is being called just to mock the submit response
            billingService.submitotpayment(pmName, amtDue).then(res => {
                console.log(res.data.confirmNumber);
                if(res.data !== null) {
                    if(res.data.confirmNumber){
                        billingService.getBpGlobalData().then((res)=>{
                            if(res && res.data && res.data.status && res.data.status.statusCode === "00000"){
                                console.log("view bpGlobalInfo: ", res.data);
                                this.bpGlobalInfo = res.data;
                                console.log("bpGlobalInfo.hasRecentPayment", this.bpGlobalInfo.hasRecentPayment);
                                this.amountTestDue = res.data.amountDue;

                                if(this.bpGlobalInfo.recentPayDate !== null) {
                                    var recentDate = this.bpGlobalInfo.recentPayDate;
                                    const parts1 = recentDate.split('/');
                                    recentDate = parts1[0] + '/' + parts1[1];
                                    this.recentPaymentDate = recentDate;
                                }

                                if(this.bpGlobalInfo.amountDue === 0 && this.bpGlobalInfo.currentBalance > 0) {
                                    this.noPaymentDuewithAccBalance = true;
                                    //omniture when pay my bill loaded with no payment due
                                    console.log('!!omniture when pay my bill loaded with no payment due');
                                    analyticsService.sendReport($scope.channelName, 'view & pay my bill', 'event1, event3', null, null, null, null, null, 
                                      $scope.omnitureBillingStatus, $scope.omniturePaperlessbill, this.$rootScope.analytics.omniturePath +'/viewpaybill');
                                    this.items = [];
                                }
                                else if(this.bpGlobalInfo.amountDue <= 0 && this.bpGlobalInfo.currentBalance === 0) {
                                    this.showAlert = true;
                                    this.items = [];
                                }

                                this.displayPaymentModal = mockService.getFalsevalue();
                                this.loading = mockService.getFalsevalue();
                                //false all the state after successful payment
                                this.isPastDue=false;
                                this.isPreDAuthOne = false;
                                this.isPreDAuthTwo = false;
                                this.paymentDue = false;
                                //this.showAlert = mockService.getTruevalue();
                                this.errorPay = false;
                                this.successPay = true;
                                //omniture order success
                                $scope.event = 'event6';
                                $scope.pageName = 'order success';
                                this.$rootScope.omnitureBillingStatus = 'cur';
                                $scope.omnitureBillingStatus = 'cur';
                                console.log('!! omniture BillingStatus : ' +this.$rootScope.omnitureBillingStatus);
                                console.log('!!omniture order success event aaray is : ' +$scope.event);
                                //document.getElementById('msgAlertBoxId').style.marginBottom = '3.3vh';
                                // document.getElementById('breadcrumb').style.marginTop = '-13.2vh';
                                document.getElementById('msgAlertBoxId').classList.add('styleAlert');
                            }
                            else{
                              this.$state.go('home.landingpage');
                            }
                        });
                    }
                    else {
                        // first clean model and it's data
                        this.displayPaymentModal = false;
                        this.loading = false;

                        //error list
                        var VALID_DECLINE = ["Do Not Honor","Processor Decline","Credit Floor","Excessive PIN try","Exceeded payment limit","Insufficient fund","Lost/Stolen","Pickup","Restraint","Invalid Field Data","Call","Suspected Fraud","Over the limit","Over Limit Frequency","No Account","Revocation of Authorization"];
                        var INVALID_CC = ["Invalid CC Number","Invalid Credit Card Number","Invalid Transaction Type","Invalid Institution Code","Invalid Card Holders Name","Invalid Card Holder","Invalid Encryption Format","Invalid Merchant","Payment Type Not Supported by Merchant"];
                        var INVALID_EXPIRY_DATE = ["Invalid Expiry Date"];
                        var INVALID_BA = ["xml tag eftt_bacct should be numeric","Numeric value out of range for xml tag eftt_bacct","Input length error for xml tag eftt_bacct"];
                        var INVALID_ROUTING_NUMBER = ["Invalid Bank or Finbr","xml tag eftt_bank is required"];
                        var TECHNICAL_FAILURE = ["Message Timed-out at Host","Error : Send_Terminal_Request","Issuer unavailable","Violation: cannot complete","No Answer","Batch XXXX not open for operator","Batch XXXX already open","Invalid Amount","Bad Amount","Other Error","Process Unavailable","Error : Conf M_P_A_OK"];
                        //end of error list
                        if(res.data.responseInfo && res.data.responseInfo.statusCode) {
                          var errorStatusCode = res.data.responseInfo.statusCode;
                          console.log("errorStatusCode:", errorStatusCode);
                        }

                        if(VALID_DECLINE.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed valid decline
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Valid Decline';
                          console.log('!!omniture order failed, valid decline event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          this.isValidDecline = true;
                          if(this.items.length === 1){
                            this.alertMsgOne = 'The payment method for your account was declined.';
                          }
                          else{
                            this.alertMsgOne = 'The payment method for your account was declined. Please select another payment method to continue.';
                          }
                          this.displayAlertModal = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else if(INVALID_CC.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed invalid CC
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Invalid CC#';
                          console.log('!!omniture order failed, invalid CC event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          this.isInvalidCC = true;
                          if(this.items.length === 1){
                            this.alertMsgOne = 'The payment method for your account  is invalid.';
                          }
                          else{
                            this.alertMsgOne = 'The payment method for your account is invalid. Please select another payment method to continue.';
                          }
                          this.displayAlertModal = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else if(INVALID_EXPIRY_DATE.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed invalid Expiry date
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Invalid Expiry Date';
                          console.log('!!omniture order failed, invalid Expiry date event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          this.isInvalidCCExDate = true;
                          if(this.items.length === 1){
                            this.alertMsgOne = 'The payment method for your account  is invalid.';
                          }
                          else{
                            this.alertMsgOne = 'The payment method for your account is invalid. Please select another payment method to continue.';
                          }
                          this.displayAlertModal = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else if(INVALID_BA.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed invalid Bank Account Number
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11'; 
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Invalid Bank account number';
                          console.log('!!omniture order failed, invalid Bank Account number event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          if(this.items.length === 1){
                            this.alertMsgOne = 'The account number you specified is invalid.';
                          }
                          else{
                            this.alertMsgOne = 'The account number you specified is invalid. Please select another payment method to continue.';
                          }
                          this.displayAlertModal = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else if(INVALID_ROUTING_NUMBER.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed, invalid Routing Number
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Invalid Routing number';
                          console.log('!!omniture order failed, invalid Routing Number event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          if(this.items.length === 1){
                            this.isRoutingOne = true;
                            this.alertMsgOne = 'The routing number you specified is invalid.';
                          }
                          else{
                            this.alertMsgOne = 'The routing number you specified is invalid. Please select another payment method to continue.';
                          }
                          this.displayAlertModal = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else if(TECHNICAL_FAILURE.indexOf(errorStatusCode)!=-1){
                          //!!omniture order failed Technical Failure
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Technical Failure';
                          console.log('!!omniture order failed, Technical Failure event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          this.alertMsgOne = 'Sorry, it looks like there is a problem processing your payment right now. Please try again later.';
                          this.displayAlertModal = true;
                          this.isTechFailureAlert = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }
                        else {
                          if(this.totalPaymentMethod > 1) {
                            $scope.event = 'event11';
                            this.totalPaymentMethod --;
                          } else {
                            $scope.event = 'event11, event10';
                            this.totalPaymentMethod --;
                          }
                          $scope.pageName = 'order failed';
                          $scope.omnitureErrorMsg = 'Technical Failure';
                          console.log('!!omniture order failed, Technical Failure event is : ' +$scope.event);
                          this.bpGlobalDataLoader = false;
                          this.alertMsgOne = 'Sorry, it looks like there is a problem processing your payment right now. Please try again later.';
                          this.displayAlertModal = true;
                          this.isTechFailureAlert = true;
                          setTimeout(function() {
                            document.getElementById('alert-confirm-btn').focus();
                          }, 100);
                        }

                    }
                }
            });
        };

        this.alertDone = () =>{
            if(!this.isTechFailureAlert){
              this.bpGlobalDataLoader = true;
              var newPaymentMethodList = [];
              var allpaymentMethods = storage.getItem('session', 'paymentMethods');
              allpaymentMethods.forEach((method)=> {
                if(method.payment_method != this.paymentMethodUsed){
                  newPaymentMethodList.push(method);
                }
              });
              storage.setItem('session', 'paymentMethods', newPaymentMethodList);
              this.items = storage.getItem('session', 'paymentMethods');
            }
            this.displayAlertModal = false;
            this.bpGlobalDataLoader = false;
            this.isValidDecline = false;
            this.isInvalidCC = false;
            this.isInvalidCCExDate = false;
            this.isRoutingOne = false;
            this.isTechFailureAlert = false;
            if(this.items.length > 0){
              this.focusItem('btn-scrolling-list');
            }
            else if(this.items.length === 0){
              this.onlyOnePaymentMethodAfterError = true;

              /* ****************************************************************************************************************/
              /*This should be added in case we need to restrict the alert to not show the user to select another payment method
              /* ****************************************************************************************************************/
              if(this.currentAccount.defaultPaymentExpired){
                //!!omniture payment method expired
                if(this.totalPaymentMethod > 1) {
                  $scope.event = 'event1, event3';
                  this.totalPaymentMethod --;
                } else {
                  $scope.event = 'event1, event3, event10';
                  this.totalPaymentMethod --;
                }
                $scope.pageName = 'view & pay my bill';
                $scope.omnitureErrorMsg = 'payment method expired';
                console.log('!!omniture payment method expired : ' +$scope.event +' Error msg : ' +$scope.omnitureErrorMsg);

                this.paymentAlertMsg= this.currentAccount.defaultPaymentName+' has expired.';
              }
            }
        };

    }

    focusItem(id) {
        const el = document.getElementById(id);
        if (el) {
            console.log('got it',el);
            el.focus();
        } else {
            console.log('I am here in non-focus state.');
            this.$timeout(this.focusItem.bind(this,id));
        }
    }

    _getTime() {
        var date = date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };

    createScheduledPayData(date, amount) {
      var time = (date != null) ? new Date(date).getTime() : null;
      return {
        date: date,
        amount: amount,
        isScheduled: function(){return this.date != null && this.amount != null},
        time : time,
        getFormattedDate : function(){
          if (time != null) {
            var date = new Date(time);
            var month = date.getMonth()+1;
            return  (month < 10 ? "0" : "") + month + "/" + date.getDate();
          }
        }
      };
  };


    getScheduledPay(autoPay,oTPay){
        var result = null;
        if (autoPay.isScheduled() && !oTPay.isScheduled()) {
          result = autoPay;
        } else if (!autoPay.isScheduled() && oTPay.isScheduled()) {
          result = oTPay;
        } else if (autoPay.isScheduled() && oTPay.isScheduled()) {
          result = (autoPay.time > oTPay.time) ? oTPay : (autoPay.time < oTPay.time) ? autoPay : (autoPay.amount > oTPay.amount) ? autoPay : oTPay;
        }
        return result;
    };

}


ViewpaybillController.$inject = ['$timeout', '$scope', 'navigationManager', 'mockService', 'authService',
  'billingService','$filter','storage','$state', '$rootScope', '$interval', '$window', 'analyticsService'];

export default ViewpaybillController;



// WEBPACK FOOTER //
// ./client/app/components/viewpaybill/viewpaybill.controller.js